import type { FC } from "react";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon, Popover, PopoverTrigger, PopoverContent } from "@tenant/ui";

import styles from "./styles.module.scss";

export const TaxesInfoPopover: FC = () => {
  const [block, cn] = useModuleBEM(styles, "TaxesInfoPopover");
  const { t } = useI18nContext();

  return (
    <Popover className={block}>
      <PopoverTrigger className={cn("button")}>
        <Icon className={cn("icon")} iconName={IconNameEnum.info} />
      </PopoverTrigger>
      <PopoverContent
        showCloseButton={false}
        align={"center"}
        className={cn("content")}
      >
        {t("hotels.priceBreakdown.payNowTaxesAndFeesInfo")}
      </PopoverContent>
    </Popover>
  );
};
